var _circle, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9849,
    cy: 15.5015,
    r: 13.3198,
    fill: "#FF9A0A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3455_40604)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0059,
    cy: 15.4942,
    r: 10.6559,
    transform: "rotate(50.7384 15.0059 15.4942)",
    fill: "url(#paint0_linear_3455_40604)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.7249 15.1504C12.7864 22.6017 6.9731 22.524 6.9731 22.524C6.9731 22.524 0.125984 14.8959 8.26223 7.2437C16.779 1.05913 23.2564 8.75047 23.2564 8.75047C23.2564 8.75047 16.6634 7.69904 14.7249 15.1504Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5916 9.36364V21H14.1314V11.6989H14.0632L11.3984 13.3693V11.1875L14.2791 9.36364H16.5916Z",
    fill: "#FFF6C9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3455_40604",
    x: 0.797651,
    y: 4.83789,
    width: 28.4164,
    height: 28.4164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.55196
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.77598
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3455_40604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3455_40604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3455_40604",
    x1: 14.797,
    y1: 3.68745,
    x2: 21.2824,
    y2: 27.0452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPlace);
export default __webpack_public_path__ + "static/media/first_place.029c62bfa0462fa56979e7ff8ea3d4eb.svg";
export { ForwardRef as ReactComponent };